import { call } from 'redux-saga/effects';

import { Notifications } from 'types';

import { webSocketService } from 'services/WebSocketService';

export function* startDrawSaga() {
  yield call(() => webSocketService.sendMessage({ type: Notifications.START_DRAW }));
}
